import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Col, Row, Table, OverlayTrigger, Tooltip, Tab, Badge } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';
import moment from 'moment/min/moment-with-locales';

//components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '../../../hoc/withLocalization';
import InputTime from '../../../components/GenericForm/Widgets/InputTime';
import GPSInfo from './GPSInfo';
import TimePickerInput from '../../../components/TimePicker';
import SwitchWidget from '../ControlPanel/SwitchWidget';
import { CostUnitsAndTypeWidget } from '../../../components/GenericForm/Widgets/CostUnitsAndTypes';
import UrgentCallModal from '../Schedule/UrgentCallManagement/UrgentCallModal.js';
import PayrollHistoryTable from '../../../components/GenericModal/PayrollHistoryTable.js';
import UserPromptModal from '../../../components/GenericModal/userPromptModal/index.js';

//elements
import Button from '../../../components/CustomButton/CustomButton.jsx';
import { Textarea } from '../../../elements/Input';
import LoadingSpinner from '~/elements/LoadingSpinner';
import { NumberInput } from '../../../elements/Input';
import Select from '../../../elements/Select.js'

//services
import agent from '../../../library/agent';

//utils
import { getMinutesFromTimeInput, minutesToTimeInput } from '../../../utils/timeCalc';
import { timeFormat, shortDateFormat } from '~/utils/dateFormat';
import { getCompanyShiftDetails, renderCompanyShiftDetails, ratioToPercent, resolvePayrollWageTypeLabel, mergeExtraOvertimeTypes } from '~/utils/commonMethods';
import { payrollIntegrationOptions } from '../../../utils/constants.js';
import { totalTimeFormat } from '../../../utils/dateFormat.js';

//assets
import ResetApprovalIcon from '../../../assets/img/resetApprovalIcon.svg';
import ApprovalIcon from '../../../assets/img/ApprovalIcon.svg';
import RejectIcon from '../../../assets/img/RejectIcon.svg';
import SaveAndAcceptIcon from '../../../assets/img/SaveAndAcceptIcon.svg';
import urgentWorkIcon from '../../../assets/img/urgent_icon.svg';

class ModalAccept extends Component {
    constructor(props) {
        super(props);
        this.isShiftAllowanceEnabled = props?.commonStore?.config?.client?.data?.extraPayments?.some(ele => ele.code === 'shift_allowance' && ele.isActive) || false;
        this.isEmergencyShiftEnabled = props?.commonStore?.config?.client?.data?.extraPayments?.some(ele => ele.code === 'emergency_shifts' && ele.isActive) || false;
        this.currentIntegrationProduct = props?.commonStore?.config?.integration_details?.product || null;
        this.companyShiftsOptions = props?.commonStore?.config?.client?.allow_company_shifts ? props?.commonStore.sortCompanyShifts(props?.commonStore.config.companyShifts, false, { F1: false, F2: false, F3: false, F4: false, F5: false })?.map(cs => ({ label: cs.shift_name, value: cs.id })) : null;
        this.state = {
            currentStatus: 'active',
            notes: '',
            showTimeEditAndComment: false,
            fromInput: '',
            toInput: '',
            breakInput: '',
            fromChangedBy: null,
            previousFrom: null,
            toChangedBy: null,
            previousTo: null,
            breakChangedBy: null,
            previousBreak: null,
            isLoading: true,
            syncWithIntegration: false,
            showShifts: false,
            shiftDetails: [],
            validationMessage: '',
            hasInterSectingShifts: null,
            updatedData: null,
            overtimes: {},
            weekly_overtimes: {},
            overtimeArray: [],
            cost_units: null,
            costUnitsHasError: false,
            currentTab: 'shifts',
            shiftAllowance: {},
            companyShiftId: null,
            isAlreadySynced: false,
            timelog: {},
            payrollDetails: [],
            showUrgentCallModal: false,
            userPromptModal: {
                source: '',
                header: '',
                showModal: false,
                sourceInfo: {},
                actionMethods: {}
            }
        };
        this.handleUrgentCallModal = this.handleUrgentCallModal.bind(this);
    }
    convertUserTypeToText(userType) {
        switch (userType) {
            case 'member':
                return 'Member';
            case 'pm':
                return 'PM';
            case 'admin':
                return 'Admin';
            default:
                return userType ? `${userType}` : '';
        }
    }

    componentDidMount() {
        this.loadData();
    }

    getShiftDetails = async (start, end, userId, isLoadShiftAllowance) => {
        const { commonStore, scheduleStore, t } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        try {
            const paramsObj = {
                start: start,
                end: end,
                userID: userId,
                isLoadShiftAllowance: isLoadShiftAllowance
            }
            const shifts = await scheduleStore.loadShiftsForApproval(paramsObj, dateTimeRules);
            if (isLoadShiftAllowance) {
                this.setState({ shiftAllowance: shifts.shiftAllowance });
            }
            return shifts.shifts;
        } catch (err) {
            console.error({ err })
            commonStore.addNotification(t(typeof err === 'string' ? err : 'Something went wrong'), null, 'error');
        }
    }

    async loadData() {
        const { timelogStore, params, commonStore, t } = this.props;
        const isIntegrationAvailable = !!this.currentIntegrationProduct;
        if (!params?.ids.length) return;
        const { timelog } = await timelogStore.load(params.ids[0]) || {};
        if (parseInt(params.count) === 1 && params.startedByWorklogButton) {
            const { data } = timelog;
            const clientInfo = commonStore.config;
            let fromChangedBy, toChangedBy, breakChangedBy;

            if (data.fromChangedById || data.toChangedById || data.breakChangedById) {
                const user = await agent.Users.load(data.fromChangedById)
                fromChangedBy = toChangedBy = breakChangedBy = user;
            }

            const shiftDetails = await this.getShiftDetails(timelog.for_date, timelog.for_date, timelog.user_id, true);
            timelog['model_name'] = 'timelog';
            let validateTimelogWithIntegration = '';
            if (isIntegrationAvailable) {
                validateTimelogWithIntegration = await timelogStore.validateTimelogWithIntegration(timelog);
            } else {
                validateTimelogWithIntegration = 'No integration available'
            }
            const isAlreadySynced = isIntegrationAvailable && ((timelog?.int_id && timelog.int_status === 'success') || timelog.int_status === 'failed') ? true : false
            let overtimes = timelog.data.overtimes;
            let overtimeArray = JSON.parse(JSON.stringify(clientInfo.client.data.basicRules.overtime_types));
            if (!clientInfo.client.allow_company_shifts && clientInfo.client.data.basicRules.overtimeAutomaticMode) {
                const code = commonStore.config.client.data.basicRules.overtimeCalcRules.calc_percent;
                if (timelog._total_hours_overtime) {
                    overtimes = {
                        [code]: {
                            code: `${clientInfo.client.data.basicRules.overtimeCalcRules.calc_percent}`,
                            value: minutesToTimeInput(timelog._total_hours_overtime, false),
                            name: `Automatic Overtime ${clientInfo.client.data.basicRules.overtimeCalcRules.calc_percent}%`
                        }
                    }
                    overtimeArray = [overtimes[code]]
                }
            }
            else if (clientInfo.client.allow_company_shifts) {
                overtimeArray = [];
                if (commonStore?.config?.overtimes?.length) {
                    commonStore.config.overtimes.forEach(ot => {
                        overtimeArray.push({
                            code: ot.overtime,
                            multiplier: ot.overtime,
                            name: ot.name
                        })
                    })
                }
                // Include overtime types already recorded on this timelog (e.g. urgent work, weekly overtime)
                // even if they aren't part of the assigned company shift's configured overtime list.
                overtimeArray = mergeExtraOvertimeTypes(
                    overtimeArray,
                    [timelog.data?.overtimes, timelog.data?.weekly_overtimes],
                    commonStore?.config?.overtimes
                );
            }

            let _payrollDetails
            if (timelog.status === 'approved' && isIntegrationAvailable)
                _payrollDetails = await timelogStore.forDateLoadIntList(timelog.user_id, moment(timelog.for_date).format('YYYY-MM-DD')) || [];

            this.setState({
                currentStatus: timelog.status,
                fromChangedBy: (fromChangedBy && fromChangedBy.user) || null,
                toChangedBy: (toChangedBy && toChangedBy.user) || null,
                breakChangedBy: (breakChangedBy && breakChangedBy.user) || null,
                previousFrom: data.previousFrom || data.previousFrom === 0 ? data.previousFrom : null,
                previousTo: data.previousTo || data.previousTo === 0 ? data.previousTo : null,
                previousBreak: data.previousBreak || data.previousBreak === 0 ? data.previousBreak : null,
                notes: timelog.status_note || '',
                admin_note: timelog.admin_note || '',
                fromInput: timelog.from,
                toInput: timelog.to,
                breakInput: minutesToTimeInput(timelog.break || 0),
                validationMessage: t(validateTimelogWithIntegration),
                shiftDetails: shiftDetails,
                syncWithIntegration: isAlreadySynced || !validateTimelogWithIntegration,
                isAlreadySynced: isAlreadySynced,
                overtimes: overtimes,
                weekly_overtimes: timelog?.data?.weekly_overtimes || {},
                overtimeArray: overtimeArray,
                cost_units: timelog?.data?.cost_units || null,
                companyShiftId: timelog.company_shift_id,
                currentTab: this.props.initialTab || this.getFirstNonEmptyTab(shiftDetails, timelog),
                timelog: timelog,
                payrollDetails: _payrollDetails
            }, () => this.setState({ isLoading: false }));
        }
        else {
            this.setState({ isLoading: false });
        }
    }

    getFirstNonEmptyTab = (shiftDetails, timelog) => {
        if (shiftDetails?.length > 0) return 'shifts';
        if (timelog?.data?.timeBank?.length > 0) return 'timebank';
        if ((timelog?.data?.overtimes && Object.values(timelog.data.overtimes).length > 0) || (timelog?.data?.weekly_overtimes && Object.values(timelog.data.weekly_overtimes).length > 0)) return 'overtime';
        if (timelog?.data?.extraPayments && Object.values(timelog.data.extraPayments).length > 0) return 'addtionals';
        return 'shifts';
    };

    async validateWorkingHours(totalHours, callback) {
        const { t } = this.props;

        const hasMatchingShift = this.state.shiftDetails?.some(shift => {
            const shiftDuration = (shift.endTime - shift.startTime) / 60;
            return Math.abs(shiftDuration - 10) <= 0.5;
        });
        if (!hasMatchingShift && totalHours > 600) {
            const shouldProceed = await new Promise(resolve => {
                confirmAlert({
                    title: t('Confirm'),
                    message: t('Are you sure you want to send more than 10 hours?'),
                    buttons: [
                        { label: t('Yes'), onClick: () => resolve(true) },
                        { label: t('No'), onClick: () => resolve(false) }
                    ]
                });
            });

            if (!shouldProceed) {
                this.setState({ isLoading: false });
                return false;
            }
        }

        if (callback && typeof callback === 'function') {
            await callback();
        }

        return true;
    }

    async handleRun(action) {
        const { timelog } = this.state;
        if (action === 'rejected' && !this.state.notes) {
            this.props.commonStore.addNotification(this.props.t('Comment is required'), null, 'error');
            return;
        }
        if (action === 'approved') {
            const totalHours = getMinutesFromTimeInput(timelog.total_hours_normal || '00:00') + getMinutesFromTimeInput(timelog.total_hours_overtime || '00:00');
            await this.validateWorkingHours(totalHours, () => this.saveAndSetStatus(action));
        } else {
            this.saveAndSetStatus(action);
        }
    }

    saveAndSetStatus = async (action) => {
        const { timelogStore, params, afterSave, commonStore, t } = this.props;
        this.setState({ isLoading: true })
        try {
            for (let i = 0; i < params.ids.length; i++) {
                await timelogStore.setStatus(params.ids[i], params.entity, action, { notes: this.state.notes, admin_note: this.state.admin_note }, this.state.syncWithIntegration);
            }
            if ((action === 'rejected' || action === 'approved') && params.entity === 'timelog') {
                if (params.ids.length === 1) {
                    await timelogStore.singlePushNotification(params.ids[0], this.state.notes, action, false);
                } else {
                    await timelogStore.massPushNotification(params.ids, this.state.notes, action);
                }
            }
            if (this.state.syncWithIntegration) commonStore.addNotification(t(`Syncing complete! The ${params.entity} is now synchronized with`) + " " + this.currentIntegrationProduct, null, 'success');
            else commonStore.addNotification(t('Saved'), null, 'success');
            afterSave();
        } catch (err) {
            console.error(err);
            const approvedWeeklyOvertime = err?.response?.body?.userPrompts?.find(ele => ele.source === 'approvedWeeklyOvertime');
            if (approvedWeeklyOvertime?.showModal) {
                this.setState({
                    userPromptModal: {
                        ...approvedWeeklyOvertime,
                        actionMethods: {
                            handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                            handleResetApprovedWeeklyOvertime: () => this.handleResetApprovedWeeklyOvertime(approvedWeeklyOvertime.sourceInfo.approvedWeeklyOvertime.approvedTimesheets)
                        }
                    }
                });
            }
        }
        finally {
            this.setState({ isLoading: false })
        }
    }

    handleCloseUserPromptModal = () => {
        this.setState({ userPromptModal: { ...this.state.userPromptModal, showModal: false } })
    }

    handleResetApprovedWeeklyOvertime = async (approvedTimesheets) => {
        const { timelogStore, commonStore, t, afterSave } = this.props;
        this.setState({ isLoading: true })
        try {
            await timelogStore.resetApprovedWeeklyOvertimeTimesheets(approvedTimesheets);
            this.handleCloseUserPromptModal();
            commonStore.addNotification(t('Approved timesheets have been reset successfully.'), null, 'success');
            afterSave();
        } catch (err) {
            console.error(err);
        }
        finally {
            this.setState({ isLoading: false })
        }
    }

    async saveOneAndAccept() {
        const { timelogStore, userStore, params, afterSave, commonStore, t } = this.props;
        const { timelog } = this.state;
        const newData = JSON.parse(JSON.stringify(timelog.data));
        const userId = userStore.currentUser.id;
        const previousFrom = getMinutesFromTimeInput(timelog.from) || timelog.from;
        const previousTo = getMinutesFromTimeInput(timelog.to) || timelog.to;
        const previousBreak = timelog.break;
        timelog.from = getMinutesFromTimeInput(this.state.fromInput);
        timelog.to = getMinutesFromTimeInput(this.state.toInput);
        timelog.break = getMinutesFromTimeInput(this.state.breakInput);
        if (timelog.from > timelog.to) {
            timelog.total_hours_normal = 1440 -
                getMinutesFromTimeInput(this.state.fromInput) +
                getMinutesFromTimeInput(this.state.toInput) -
                getMinutesFromTimeInput(this.state.breakInput);
        }
        else {
            timelog.total_hours_normal =
                getMinutesFromTimeInput(this.state.toInput) -
                getMinutesFromTimeInput(this.state.fromInput) -
                getMinutesFromTimeInput(this.state.breakInput);
        }
        newData.fromChangedById = userId;
        newData.previousFrom = previousFrom;
        newData.previousTo = previousTo;
        newData.toChangedById = userId;
        newData.breakChangedById = userId;
        newData.previousBreak = previousBreak;
        newData.status_notes = this.state.notes;
        timelog.data = newData;
        timelog.data.extraPayments = this.state.updatedData ? this.state.updatedData.extraPayments : newData.extraPayments;
        timelog.status = 'approved';
        timelog.status_note = this.state.notes;
        timelog.admin_note = this.state.admin_note
        timelog.status_changed_by = userId;
        timelog.status_changed_on = new Date();
        timelog.overrideClearStatusNote = true;
        timelog.sendPushStatusNote = true;
        timelog.company_shift_id = this.state.companyShiftId;
        if (this.state.cost_units !== null) {
            timelog.data.cost_units = this.state.cost_units;
        }

        await this.validateWorkingHours(timelog.total_hours_normal, async () => {
            await timelogStore.saveAndOverrideCurrentEntity(timelog, false);
            this.setState({ isLoading: true });
            const getMessage = await timelogStore.singlePushNotification(params.ids[0], this.state.notes, 'changed and approved', this.state.syncWithIntegration);
            commonStore.addNotification(t(getMessage.message), null, 'success');
            afterSave();
            this.setState({ isLoading: false });
        });
    }

    isDataModified = () => {
        const { params } = this.props;
        if (!params || !params.ids || !params.ids.length) return false;
        const { timelog } = this.state;
        if (!timelog) return true;
        if (this.state.updatedData?.extraPayments && timelog.data?.extraPayments) {
            for (let i = 0; i < Object.keys(this.state.updatedData.extraPayments).length; i++) {
                for (let j = 0; j < Object.keys(timelog.data.extraPayments).length; j++) {
                    if (Object.keys(this.state.updatedData.extraPayments)[i] === Object.keys(timelog.data.extraPayments)[j]) {
                        if (Object.values(this.state.updatedData.extraPayments)[i].value !== Object.values(timelog.data.extraPayments)[j].value) {
                            return true
                        }
                    }
                }
            }
        }
        if (timelog.data.cost_units && this.state.cost_units !== null) {
            const actualValue = JSON.parse(timelog.data.cost_units)?.reduce((a, e) => a + e.dimensionIdentifier + e.id, "") || "";
            const modifiedValue = JSON.parse(this.state.cost_units)?.reduce((a, e) => a + e.dimensionIdentifier + e.id, "") || "";
            if (actualValue !== modifiedValue)
                return true;
        }
        return timelog.from !== this.state.fromInput || timelog.to !== this.state.toInput || minutesToTimeInput(timelog.break) !== this.state.breakInput;
    }

    isStatusUpdated = () => {
        const { currentStatus } = this.state
        return currentStatus !== 'active';
    }

    handleSyncSwitch = (value) => {
        this.setState({ syncWithIntegration: value })
    }

    handleChangeExtraPayments = (extraPayment, value) => {
        const { timelogStore } = this.props;
        const updatedData = timelogStore.handleChangeExtraPayments(extraPayment, value, true)
        this.setState({ updatedData })
    };

    handleCostUnitChange = (value) => {
        this.setState({ cost_units: value });
    }

    handleCostUnitsError = (value, hasError) => {
        const { t, commonStore } = this.props;
        this.setState({ cost_units: value, costUnitsHasError: hasError });
        const errorMsg = t("Some of the previously selected cost-units had expired, system removed them to avoid inconsistency, if needed update on payroll and then refetch here.");
        commonStore.addNotification(errorMsg, null, 'warning', "top-right", 3000);
    }

    handleChangeBreakForDisableAutoBreakUser = () => {
        confirmAlert({
            title: this.props.t('Are You Sure'),
            message: this.props.t("Break is disabled in profile. Do you still want to add break?"),
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => {
                        this.setState({
                            breakInput: 0
                        })
                    },
                },
            ],
        })
    }

    handleStandardHoursChanges = () => {
        const { commonStore } = this.props;
        const clientInfo = commonStore.config;
        const { companyShiftId, timelog } = this.state;
        const companyShift = getCompanyShiftDetails(clientInfo, companyShiftId, minutesToTimeInput);
        this.setState({
            fromInput: companyShift.start,
            toInput: companyShift.end,
            breakInput: minutesToTimeInput(companyShift.break)
        }, () => {
            if (!timelog.User.auto_break && companyShift.break) {
                this.handleChangeBreakForDisableAutoBreakUser()
            }
        });
    }

    handleCompanyShiftChange = (companyShiftId) => {
        confirmAlert({
            title: this.props.t('Are You Sure'),
            message: this.props.t("Changing the company shift may result in overwritting the timesheet calculations (like clock in-out, break, overtimes), do you still want to continue") + ' ?',
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                        this.setState({ companyShiftId: companyShiftId }, this.handleStandardHoursChanges);
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => { },
                },
            ],
        })
    }

    formateIntegrationSuccessData = (intData, intOvertimeData, isAdminManagedOvertime, total_hours_normal) => {
        const { t } = this.props;
        return (<div className="bg-white border rounded shadow-sm p-3" style={{ maxWidth: "20rem" }}>
            <div className="d-flex align-items-center mb-2">
                <i className="fa fa-check-circle text-success me-2"></i>
                <span className="small fw-medium text-success"> {t('Timelog Registered')}</span>
            </div>
            {intData && (!isAdminManagedOvertime || total_hours_normal > 0) && <div className="small text-muted mb-3">
                <div className="fw-semibold text-dark mb-1">
                    {intData?.activity?.description}
                </div>

                {[
                    { label: "Date", value: intData?.assignmentDate },
                    { label: "Hours", value: intData?.workingHours },
                ].map((item, idx) => (
                    <div key={idx} className="d-flex justify-content-between">
                        <span className="text-secondary">{t(item.label)}:</span>
                        <span className="text-truncate fw-semibold ms-2 text-dark">{t(item.value)}</span>
                    </div>
                ))}
            </div>}

            {intOvertimeData?.map((ot, index) => (
                <div key={index} className="small text-muted border-top pt-2 mt-2">
                    <div className="fw-semibold text-dark mb-1">
                        {ot?.int_data?.addTimesheets?.[0]?.activity?.description} ({t('Overtime')}/{t('Additionals')})
                    </div>

                    {[
                        { label: "Date", value: ot?.int_data?.addTimesheets?.[0]?.assignmentDate || ot?.int_data?.assignmentDate },
                        { label: "Hours", value: ot?.int_data?.addTimesheets?.[0]?.workingHours || ot?.int_data?.workingHours },
                        { label: "TimeType", value: ot?.int_data?.addTimesheets?.[0]?.timeType?.description || ot?.int_data?.timeType?.description },
                    ].map((item, idx) => (
                        <div key={idx} className="d-flex justify-content-between">
                            <span className="text-secondary">{t(item.label)}:</span>
                            <span className="text-truncate fw-semibold ms-2 text-dark">{t(item.value)}</span>
                        </div>
                    ))}
                </div>
            ))}
        </div>)
    }

    renderCompanyShift = (companyShiftId, dateTimeRules) => {
        const { t, commonStore } = this.props;
        const companyShift = commonStore?.config?.companyShifts.find(cs => cs.id === companyShiftId);
        if (!companyShift) return null;
        return (
            <div>
                <span className="fw-bold me-2">{t('Working Shift')}:</span>
                <span>{companyShift.shift_name}</span>
                <OverlayTrigger
                    placement="right"
                    overlay={
                        <Tooltip id="shift-details-tooltip">
                            <div style={{ textAlign: 'left' }}>
                                {renderCompanyShiftDetails(companyShift, t, minutesToTimeInput, timeFormat, dateTimeRules)}
                            </div>
                        </Tooltip>
                    }
                ><i className="fa fa-info-circle text-muted ms-1 mt-1" style={{ opacity: '0.5' }} aria-hidden="true"></i></OverlayTrigger>
            </div>
        )
    }

    handleUrgentCallModal = (toggle) => {
        this.setState({ showUrgentCallModal: toggle });
    }

    render() {
        if (this.state.isLoading)
            return <LoadingSpinner />;

        const { timelogStore, t, params, commonStore, userStore } = this.props;
        const { fromChangedBy, previousFrom, currentTab, shiftAllowance, payrollDetails,
            toChangedBy, previousTo, breakChangedBy, previousBreak, overtimes, weekly_overtimes,
            overtimeArray, timelog, showUrgentCallModal, userPromptModal } = this.state;
        const overtimesCount = (overtimes ? Object.keys(overtimes).length : 0) + (weekly_overtimes ? Object.keys(weekly_overtimes).length : 0);
        const allowTimeBank = commonStore?.config?.client?.data?.basicRules?.timeBankSettings?.allowTimeBank;
        if (!params) return null;
        const dateTimeRules = commonStore.getDateTimeRules();

        const { user_type, id: currentUserId } = userStore.currentUser;
        const preventPmSelfApproval = commonStore?.config?.client?.data?.basicRules?.preventPmSelfApproval;
        const isSelfApprovalBlocked = preventPmSelfApproval && user_type === 'pm' && parseInt(timelog.user_id) === parseInt(currentUserId);
        const selfApprovalMessage = t('You cannot approve, reject or reset your own request');

        const timesheetHasTimeBank = timelogStore.validateTimelogifTimeBankPresent(timelog, commonStore.config);

        if (params.entity === 'timelog' && shiftAllowance) {
            if (!timelog.data) timelog.data = {};
            if (!timelog.data?.extraPayments) timelog.data.extraPayments = {};
            let data = {
                ...timelog.data.extraPayments, 'shift_allowance': {
                    value: shiftAllowance.amount, extraPaymentType: {
                        value: "fixed_hourly_amount",
                        label: "Fixed amount for shift"
                    },
                }
            }
            if (data) timelog.data.extraPayments = data;
        }

        const payrollDetailsForTimelog = payrollDetails?.rows?.length ? payrollDetails.rows.find(ele => ele.id === timelog.id)?.int_data_array : [];

        //timelog grid --start//
        const format = dateTimeRules && dateTimeRules.time_format ? dateTimeRules.time_format : 'hh:mm';
        return (
            <div className="mb-5">
                <div className="primary-page__title mt-2">{t('User')} {t('Details')}</div>
                <div className="row timelog-grid-time-card mt-2">
                    <Col xs={12} md={6}
                        className="timelog-grid-item-1 justify-content-space-between card-timelog-grid-item"
                    >
                        <div className="d-flex">
                            <i className="timelog-grid__icon"></i>
                            <span className="timelog-grid__text" style={{ width: 'fit-content', textTransform: 'capitalize' }}>
                                {timelog.User.first_name} {timelog.User.last_name}
                            </span>
                            {this.currentIntegrationProduct === payrollIntegrationOptions.XLEDGER && (timelog.int_status === 'success' || (timelog.overtime_int_data && timelog.overtime_int_data.length > 0)) && <OverlayTrigger
                                overlay={
                                    <Tooltip id={`user-tooltip-${timelog.User.id}`}>
                                        {this.formateIntegrationSuccessData(timelog.int_data, timelog.overtime_int_data, timelog?.data?.isAdminManagedOvertime, getMinutesFromTimeInput(timelog.total_hours_normal))}
                                    </Tooltip>
                                }
                                placement='bottom'
                            >
                                <i className="fa fa-info-circle text-muted" style={{ fontSize: '0.9em', opacity: 0.7 }} />
                            </OverlayTrigger>}
                        </div>
                        <b className="timelog-final-time-card-modal align-self-center">
                            {t('Remuneration type')} - {t(timelog.User.payment_mode)}
                        </b>
                    </Col>
                    <Col xs={12} md={6}
                        className="timelog-grid-item-2 justify-content-space-between card-timelog-grid-item"
                    >
                        <div className="d-flex align-items-center">
                            <i className="timelog-grid__icon"></i>
                            <span className="timelog-grid__text">{t('For Date')}</span>
                        </div>
                        <b className="timelog-final-time-card-modal align-self-center">
                            {timelog.status === 'active' && timelog.from > timelog.to ?
                                `${shortDateFormat(timelog.for_date, dateTimeRules)} | ${shortDateFormat(moment(timelog.for_date).add(1, 'days'), dateTimeRules)}` :
                                shortDateFormat(timelog.for_date, dateTimeRules)
                            }
                        </b>
                    </Col>
                </div>
                <div className="primary-page__title mt-2">{t('Registered working hours')}</div>
                <div className="row timelog-grid-time-card mt-2">
                    <Col xs={12} md={6}
                        className="timelog-grid-item-1 justify-content-space-between card-timelog-grid-item"
                    >
                        <div className="d-flex">
                            <i className="timelog-grid__icon"></i>
                            <span className="timelog-grid__text">{t('Start')}</span>
                        </div>
                        <b className="timelog-final-time-card-modal">
                            {timelog.from}
                        </b>
                    </Col>
                    <Col xs={12} md={6}
                        className="timelog-grid-item-2 justify-content-space-between card-timelog-grid-item"
                    >
                        <div className="d-flex align-items-center">
                            <i className="timelog-grid__icon"></i>
                            <span className="timelog-grid__text">{t('End')}</span>
                        </div>
                        <b className="timelog-final-time-card-modal">
                            {timelog.to}
                        </b>
                    </Col>
                </div>
                <div className="row timelog-grid-time-card">
                    <Col xs={12} md={6}
                        className="timelog-grid-item-1 justify-content-space-between card-timelog-grid-item"
                    >
                        <div className="d-flex align-items-center">
                            <span className="timelog-grid__text ml-30">{t('Breaktime')}</span>
                        </div>
                        <b className="timelog-final-time-card-modal">
                            {minutesToTimeInput(timelog.break || 0)}
                        </b>
                    </Col>
                    <Col xs={12} md={6}
                        className="timelog-grid-item-2 justify-content-space-between card-timelog-grid-item"
                    >
                        <div className="d-flex align-items-center">
                            <span className="timelog-grid__text ml-30">{t('Total')}</span>
                        </div>
                        <b className="timelog-final-time-card-modal">
                            {timelog.data?.isExcludeNormalHoursTask && <span className="me-2">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="tooltip-exclude-normal-hours">{t('This timesheet includes additional payments, which exclude normal working hours')}</Tooltip>}
                                ><i className="fa fa-info-circle text-warning ms-1" aria-hidden="true"></i></OverlayTrigger>
                            </span>}
                            {getMinutesFromTimeInput(timelog.from) > getMinutesFromTimeInput(timelog.to) ?
                                minutesToTimeInput(1440 - getMinutesFromTimeInput(timelog.from) + getMinutesFromTimeInput(timelog.to) - (timelog.break || 0)) :
                                minutesToTimeInput(getMinutesFromTimeInput(timelog.to) - getMinutesFromTimeInput(timelog.from) - (timelog.break || 0))
                            }
                        </b>
                    </Col>
                </div>
                {timelog.auto_logout && timelog.status === 'active' &&
                    <span className="d-flex font-size-12 p-2 text-danger align-items-center fw-600">
                        <span className='font-size-15'><strong>{t("Note")}:&nbsp;</strong></span>
                        {t("This log was auto clocked out for exceeding the configured work hour limit. Please review and save it to enable related calculations like overtime and additional payments.")}
                    </span>
                }
                {!timelog.data.toChangedById && (timelog.anomaly?.start?.is_early || timelog.anomaly?.start?.is_late || timelog.anomaly?.start?.is_offsite || timelog.anomaly?.end?.is_early || timelog.anomaly?.end?.is_late || timelog.anomaly?.end?.is_offsite) ?
                    <div className='row gx-0 justify-content-center mt-2 fw-bold'>
                        {timelog.anomaly?.start?.is_early || timelog.anomaly?.start?.is_late || timelog.anomaly?.start?.is_offsite ?
                            <>
                                <Row className='w-100'>
                                    <Col className='d-flex justify-content-around' xs={12} md={6}>
                                        <div>{t('Clock In')}:&nbsp;</div>
                                        <div className={`d-flex align-items-center ${timelog.anomaly?.start?.is_late ? 'text-danger' : timelog.anomaly?.start?.is_early ? "text-warning " : "text-success"}`}>
                                            <i className='fa fa-clock-o' />
                                            {timelog.anomaly?.start?.is_late ? t('Late') : timelog.anomaly?.start?.is_early ? t('Early') : t('On-time')}
                                        </div>
                                    </Col>
                                    <Col className='d-flex justify-content-around' xs={12} md={6}>
                                        <div>{t('Location')}:&nbsp;</div>
                                        <div className={`d-flex align-items-center ${timelog.anomaly?.start?.is_offsite ? "text-danger d-flex align-items-center" : "text-success"}`}>
                                            <i className='fa fa-map-marker' />
                                            {timelog.anomaly?.start?.is_offsite ? t('Off-site') : t('On-site')}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='w-100 mt-2 d-flex mb-3'>
                                    <div className='d-flex justify-content-start border-bottom'>
                                        <div className='w-25 d-md-flex justify-content-md-center mb-2'>{`${t('Comment')}`}:&nbsp;</div>
                                        <div className='w-75 text-info'>{t(timelog.anomaly?.start?.comment)}</div>
                                    </div>
                                </Row>
                            </>
                            : null
                        }
                        {timelog.anomaly?.end?.is_early || timelog.anomaly?.end?.is_late || timelog.anomaly?.end?.is_offsite ?
                            <>
                                <Row className='w-100'>
                                    <Col className='d-flex justify-content-around' xs={12} md={6}>
                                        <div>{t('Clock Out')}:&nbsp;</div>
                                        <div className={timelog.anomaly?.end?.is_late ? "text-danger" : timelog.anomaly?.end?.is_early ? "text-warning" : "text-success"}>
                                            <i className='fa fa-clock-o' />
                                            {timelog.anomaly?.end?.is_late ? t('Late') : timelog.anomaly?.end?.is_early ? t('Early') : t('On-time')}
                                        </div>
                                    </Col>
                                    <Col className='d-flex justify-content-around' xs={12} md={6}>
                                        <div>{t('Location')}:&nbsp;</div>
                                        <div className={timelog.anomaly?.end?.is_offsite ? "text-danger" : "text-success"}>
                                            <i className='fa fa-map-marker' />
                                            {timelog.anomaly?.end?.is_offsite ? t('Off-site') : t('On-site')}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='w-100 mt-2 mb-2'>
                                    <Col xs={12} md={12}>
                                        <div className='d-flex justify-content-start'>
                                            <div className='w-25 d-md-flex justify-content-md-center'>{`${t('Comment')}`}:&nbsp;</div>
                                            <div className='w-75 text-info'>{t(timelog.anomaly?.end?.comment)}</div>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                            : null
                        }
                    </div>
                    : null
                }
                <div className={`d-flex mb-2 ${this.state.companyShiftId ? "justify-content-space-between align-items-center" : "justify-content-end"}`}>
                    {this.state.companyShiftId && this.renderCompanyShift(this.state.companyShiftId, dateTimeRules)}
                    <div className='d-flex gap-2'>
                        {timelog.employeeIsAssignedForUrgentCall &&
                            <OverlayTrigger
                                key="view_urgent_work_modal"
                                placement="top"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t(timelog.is_editable ?
                                            'View'
                                            : 'Cannot manage this timesheet')}
                                    </Tooltip>
                                }
                            >
                                <Button wd
                                    disabled={showUrgentCallModal || !timelog.is_editable}
                                    onClick={() => this.handleUrgentCallModal(true)}
                                >
                                    <img src={urgentWorkIcon} alt={t("Urgent work")} style={{ width: '24px', height: '24px' }} /> {t('Urgent work')}
                                </Button>
                            </OverlayTrigger>
                        }
                        <GPSInfo
                            status={timelog.status}
                            data={timelog.gps_data}
                            full={timelog}
                            mode="modal"
                        />
                        <OverlayTrigger
                            key="timelog_edit"
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t(timelog.is_editable ?
                                        timelog.status === 'approved' ?
                                            'Please reset first to change approval status'
                                            : timesheetHasTimeBank ?
                                                'This timesheet cannot be updated as it contains timebank hours. Please remove the timebank hours and try again.'
                                                : 'Adjust Timesheet'
                                        : 'Cannot manage this timesheet')}
                                </Tooltip>
                            }
                        >
                            <Button fill wd
                                onClick={() =>
                                    this.setState((state) => ({
                                        showTimeEditAndComment: !state.showTimeEditAndComment,
                                    }))
                                }
                                disabled={(timelog.status === 'approved' || !timelog.is_editable || timesheetHasTimeBank)}
                            >
                                {t('Adjust')}
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
                {timelog.status === 'rejected' &&
                    <div className='text-danger mb-2'>
                        {`${t('Note')}: ${t('Overtimes and Timebank hours are removed as this timesheet was rejected, on reset it will be added automatically if applicable')}`}
                    </div>
                }
                {this.state.showTimeEditAndComment && (
                    <div>
                        <div className="primary-page__title mt-2">{t('Working hours adjustments')}</div>
                        {this.companyShiftsOptions &&
                            <div className='row align-items-center mb-2'>
                                <div className='col-6 col-sm-4 col-md-3 fw-bold'>
                                    {t('Working Shift')}
                                </div>
                                <div className='col-6 col-md-3'>
                                    <Select
                                        options={this.companyShiftsOptions}
                                        value={this.companyShiftsOptions.find(item => item.value === this.state.companyShiftId)}
                                        onChange={evt => this.handleCompanyShiftChange(evt.value)}
                                        placeholder={`${t('Select')} ${t('Shift')}`}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                        }
                        <div className="row timelog-grid-time-card">
                            <Col xs={12} md={6}
                                className="timelog-grid-item-1 justify-content-space-between card-timelog-grid-item height-50"
                            >
                                <div className="d-flex align-items-center">
                                    <i className="timelog-grid__icon"></i>
                                    <span className="timelog-grid__text">{t('Start')}</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <TimePickerInput
                                        value={this.state.fromInput}
                                        format={format === 'hh:mm' ? 'HH:mm' : format}
                                        onChange={(value) => this.setState({ fromInput: value })}
                                        className="worklog-input border-radius-10 borderworklog"
                                    />
                                </div>
                            </Col>
                            <Col xs={12} md={6}
                                className="timelog-grid-item-2 justify-content-space-between card-timelog-grid-item height-50"
                            >
                                <div className="d-flex align-items-center">
                                    <i className="timelog-grid__icon"></i>
                                    <span className="timelog-grid__text">{t('End')}</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <TimePickerInput
                                        style={{ width: 150 }}
                                        value={this.state.toInput}
                                        format={format === 'hh:mm' ? 'HH:mm' : format}
                                        onChange={(value) => this.setState({ toInput: value })}
                                        className="worklog-input border-radius-10 borderworklog"
                                    />
                                </div>
                            </Col>
                        </div>
                        <div className="row timelog-grid-time-card">
                            <Col xs={12} md={6}
                                className="timelog-grid-item-1 justify-content-space-between card-timelog-grid-item height-50"
                            >
                                <div className="d-flex align-items-center">
                                    <span className="timelog-grid__text ml-30">{t('Breaktime')}</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <InputTime
                                        value={this.state.breakInput}
                                        onChange={(e) => {
                                            if (!timelog.User.auto_break && !getMinutesFromTimeInput(this.state.breakInput) && getMinutesFromTimeInput(e)) {
                                                this.handleChangeBreakForDisableAutoBreakUser()
                                            }
                                            this.setState({
                                                breakInput: e,
                                            });
                                        }}
                                        className="big-input text-center timelog-final-time-card-total"
                                    />
                                </div>
                            </Col>
                            <Col xs={12} md={6}
                                className="timelog-grid-item-2 justify-content-space-between card-timelog-grid-item height-50"
                            >
                                <div className="d-flex align-items-center">
                                    <span className="timelog-grid__text ml-30">{t('Total')}</span>
                                </div>
                                <b className="timelog-final-time-card-modal">
                                    {this.state.fromInput > this.state.toInput ?
                                        minutesToTimeInput(
                                            1440 - getMinutesFromTimeInput(this.state.fromInput)
                                            + getMinutesFromTimeInput(this.state.toInput)
                                            - getMinutesFromTimeInput(this.state.breakInput))
                                        :
                                        minutesToTimeInput(
                                            getMinutesFromTimeInput(this.state.toInput)
                                            - getMinutesFromTimeInput(this.state.fromInput)
                                            - getMinutesFromTimeInput(this.state.breakInput))
                                    }
                                </b>
                            </Col>
                        </div>
                        {!this.companyShiftsOptions &&
                            <div className="d-flex justify-content-end">
                                <Button fill dynamic_lg
                                    onClick={this.handleStandardHoursChanges}
                                >
                                    {t('Standard company time')}
                                </Button>
                            </div>
                        }
                    </div>
                )}
                <Row>
                    <Col sm={3} className='mt-2'>
                        <ul className="list-group">
                            {timelog.status === 'approved' &&
                                <li className={currentTab === 'payroll' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                    onClick={() => this.setState({ currentTab: 'payroll' })}>
                                    <div>
                                        {t('Payroll details')}
                                        <Badge className='ms-2 bg-secondary float-end'>{payrollDetailsForTimelog.length}</Badge>
                                    </div>
                                </li>
                            }
                            <li className={currentTab === 'shifts' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                onClick={() => this.setState({ currentTab: 'shifts' })}>
                                <div>
                                    {t('shifts')}
                                    <Badge className='ms-2 bg-secondary float-end'>{this.state?.shiftDetails?.length}</Badge>
                                </div>
                            </li>
                            {allowTimeBank &&
                                <li className={currentTab === 'timebank' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                    onClick={() => this.setState({ currentTab: 'timebank' })}>
                                    <div>
                                        {t('Time Bank')}
                                        <Badge className='ms-2 bg-secondary float-end'>{timelog?.data?.timeBank?.length || 0}</Badge>
                                    </div>
                                </li>
                            }
                            <li className={currentTab === 'overtime' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                onClick={() => this.setState({ currentTab: 'overtime' })}>
                                <div>
                                    {t('Overtime Hours')}
                                    {timelog.isOvertimeCommentMissing &&
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip-top">
                                                    {t('Comment for overtime is missing')}
                                                </Tooltip>
                                            }
                                        >
                                            <i className="fa fa-exclamation-triangle text-warning ms-2" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    }
                                    <Badge className='ms-2 bg-secondary float-end'>{overtimesCount}</Badge>
                                </div>
                            </li>
                            <li className={currentTab === 'addtionals' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                onClick={() => this.setState({ currentTab: 'addtionals' })}>
                                <div>
                                    {t('Additional Hours')}
                                    <Badge className='ms-2 bg-secondary float-end'>{timelog.data?.extraPayments ? Object.values(timelog.data?.extraPayments).length : 0}</Badge>
                                </div>
                            </li>
                            {this.state.cost_units &&
                                <li className={currentTab === 'costUnits' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                    onClick={() => this.setState({ currentTab: 'costUnits' })}>
                                    <div>
                                        {t('Cost Units')}
                                        {this.state.costUnitsHasError &&
                                            <OverlayTrigger
                                                placement="right"
                                                overlay={
                                                    <Tooltip id="tooltip-top">
                                                        {t('Please make sure to save and accept as some of the expired cost units had been removed')}
                                                    </Tooltip>
                                                }
                                            >
                                                <i className="fa fa-exclamation-circle text-danger m-2" aria-hidden="true"></i>
                                            </OverlayTrigger>
                                        }
                                        <Badge className='ms-2 bg-secondary float-end'>{JSON.parse(this.state.cost_units)?.length}</Badge>
                                    </div>
                                </li>
                            }
                            {!!this.currentIntegrationProduct && (<li className={currentTab === 'payrollHistory' ? 'list-group-item active cursor-pointer' : 'list-group-item cursor-pointer'}
                                onClick={() => this.setState({ currentTab: 'payrollHistory' })}>
                                <div>
                                    {t('Payroll')} {t('History')}
                                    <Badge className='ms-2 bg-secondary float-end'>{timelog.data?.integrationSyncHistory ? timelog.data?.integrationSyncHistory.length : 0}</Badge>
                                </div>
                            </li>)}
                        </ul>
                    </Col>
                    <Col sm={9}>
                        <Tab.Container activeKey={currentTab} id='modal-accept'>
                            <Tab.Content>
                                {payrollDetailsForTimelog.length ?
                                    <Tab.Pane eventKey="payroll">
                                        <h5 className='fw-600'>{t('Payroll details')}</h5>
                                        <div className='timelog-array__right w-100'>
                                            <Table className='w-100 '>
                                                <thead>
                                                    <tr className='w-100'>
                                                        <th width={'25%'}>{t('Name')}</th>
                                                        <th width={'25%'}>{t('Hours')}</th>
                                                        <th width={'25%'}>{t('Status')}</th>
                                                        <th width={'25%'}>{t('Wage Type')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {payrollDetailsForTimelog.map((ele, idx) => {
                                                        if (!ele) return null;
                                                        // manual point payments are a quantity (0-1), not hours — show the point value (matches what is sent to payroll)
                                                        const pointEp = timelog.data?.extraPayments
                                                            ? Object.values(timelog.data.extraPayments).find(ep => ep?.extraPaymentType?.value === 'manual_point_amount' && ep?.name === ele.name)
                                                            : null;
                                                        return (
                                                            <tr key={idx} className='text-capitalize mt-1'>
                                                                <td width={'25%'} className=''><div className='d-flex align-items-center justify-content-center min-height-20 ps-2'>{ele.name}</div></td>
                                                                <td width={'25%'} className='timelog_array_details'>{pointEp
                                                                    ? pointEp.value
                                                                    : ele.hours ? totalTimeFormat(ele.hours * 60, dateTimeRules) : '-'}</td>
                                                                <td width={'25%'} className='timelog_array_details'>{ele.status}</td>
                                                                <td width={'25%'} className='timelog_array_details'>{resolvePayrollWageTypeLabel(ele.payrollWageType, commonStore)}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Tab.Pane>
                                    : null
                                }
                                <Tab.Pane eventKey="shifts">
                                    <h5 className='fw-600'>{t('shifts')}</h5>
                                    {this.state.shiftDetails?.length ?
                                        <div className='timelog-array__right w-100'>
                                            <Table className='w-100 '>
                                                <thead>
                                                    <tr className='w-100'>
                                                        <th width={'25%'}>{t('Project')}</th>
                                                        <th width={'25%'}>{t('Task')}</th>
                                                        <th width={'25%'}>{t('Date')}</th>
                                                        <th width={'25%'}>{t('Time')}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.shiftDetails.map((ele, idx) => (
                                                        <tr key={idx} className='text-capitalize mt-1'>
                                                            <td width={'25%'} className=''><div className='d-flex align-items-center justify-content-center min-height-20 ps-2'>{ele.projectName}</div></td>
                                                            <td width={'25%'} className='timelog_array_details'>{ele.taskName}</td>
                                                            <td width={'25%'} className='timelog_array_details'>{shortDateFormat(ele.forDate, dateTimeRules)}</td>
                                                            <td width={'25%'} className='timelog_array_details'>{ele.title}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                        :
                                        <div className='text-center'>
                                            {t('No Shifts Found for the day')}!
                                        </div>
                                    }
                                </Tab.Pane>
                                <Tab.Pane eventKey="timebank">
                                    <h5 className='fw-600 mb-1'>{t('Time Bank')}</h5>
                                    {timelog.data?.timeBank && timelog.data?.timeBank.length ?
                                        <>
                                            <Row>
                                                <Table className='w-100 mt-0'>
                                                    <thead>
                                                        <tr className='w-100'>
                                                            <th width={'25%'}>{t('Name')}</th>
                                                            <th width={'25%'}>{t('Hours')}</th>
                                                            <th width={'25%'}>{t('Ratio')}</th>
                                                            <th width={'25%'}>{t('Calculated Hours')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {timelog.data?.timeBank.map((ele, idx) => (
                                                            ele.value ?
                                                                <tr key={idx} className='text-capitalize mt-1'>
                                                                    <td width={'25%'} className=''><div className='d-flex align-items-center justify-content-center min-height-20 ps-2'>{t('Time Bank')} {t('Ratio')} {ele.type === 'normal' ? `(${t('flexitime')})` : `(${ele.type} ${ratioToPercent(ele?.ratio)}%)`}</div></td>
                                                                    <td width={'25%'} className='timelog_array_details'>{totalTimeFormat(ele.value, dateTimeRules)}</td>
                                                                    <td width={'25%'} className='timelog_array_details'>{ele.ratio}</td>
                                                                    <td width={'25%'} className='timelog_array_details'>{totalTimeFormat(ele.value * ele.ratio, dateTimeRules)}</td>
                                                                </tr>
                                                                : null
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Row>
                                        </>
                                        :
                                        <div className='text-center'>
                                            {t('No Timebank Record Found')}!
                                        </div>}
                                </Tab.Pane>
                                <Tab.Pane eventKey="overtime">
                                    <div className='fw-600'>
                                        {t('Overtimes Hours')}
                                        {timelog.isOvertimeCommentMissing &&
                                            <span className='text-warning ms-2'>
                                                <i className="fa fa-exclamation-triangle me-1" aria-hidden="true"></i>
                                                {t('Comment for overtime is missing')}
                                            </span>
                                        }
                                    </div>
                                    {!!overtimesCount ?
                                        <>
                                            <div className="row timelog-grid-time-card">
                                                <Table className='w-100 mt-0'>
                                                    <thead>
                                                        <tr className='w-100'>
                                                            <th width={'25%'}>{t('Name')}</th>
                                                            <th width={'25%'}>{t('Hours')}</th>
                                                            <th width={'25%'}>{t('Ratio')}</th>
                                                            <th width={'25%'}>{t('Calculated Hours')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {overtimeArray && overtimeArray.length && !!overtimes &&
                                                            overtimeArray.map((overtime, index) => (
                                                                overtimes[overtime?.code]?.value ?
                                                                    <tr key={index} className='text-capitalize mt-1'>
                                                                        <td width={'25%'} className=''><div className='d-flex align-items-center justify-content-center min-height-20 ps-2'>{overtime.name}</div></td>
                                                                        <td width={'25%'} className='timelog_array_details'>{totalTimeFormat(overtimes[overtime.code] ? getMinutesFromTimeInput(overtimes[overtime.code].value) : 0, dateTimeRules)}</td>
                                                                        <td width={'25%'} className='timelog_array_details'>{parseInt(overtime.code) / 100 + 1}</td>
                                                                        <td width={'25%'} className='timelog_array_details'>{totalTimeFormat(overtimes[overtime.code] ? getMinutesFromTimeInput(overtimes[overtime.code].value) * (parseInt(overtime.code) / 100 + 1) : 0, dateTimeRules)}</td>
                                                                    </tr>
                                                                    : null
                                                            ))}
                                                        {overtimeArray && overtimeArray.length && !!weekly_overtimes &&
                                                            overtimeArray.map((overtime, index) => (
                                                                weekly_overtimes[overtime?.code]?.value ?
                                                                    <tr key={index} className='text-capitalize mt-1'>
                                                                        <td width={'25%'} className=''><div className='d-flex align-items-center justify-content-center min-height-20 ps-2'>{weekly_overtimes[overtime.code].name}</div></td>
                                                                        <td width={'25%'} className='timelog_array_details'>{totalTimeFormat(weekly_overtimes[overtime.code] ? getMinutesFromTimeInput(weekly_overtimes[overtime.code].value) : 0, dateTimeRules)}</td>
                                                                        <td width={'25%'} className='timelog_array_details'>{parseInt(overtime.code) / 100 + 1}</td>
                                                                        <td width={'25%'} className='timelog_array_details'>{totalTimeFormat(weekly_overtimes[overtime.code] ? getMinutesFromTimeInput(weekly_overtimes[overtime.code].value) * (parseInt(overtime.code) / 100 + 1) : 0, dateTimeRules)}</td>
                                                                    </tr>
                                                                    : null
                                                            ))}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </>
                                        :
                                        <div className='text-center'>
                                            {t('No Overtime Record Found for the day')}!
                                        </div>}
                                </Tab.Pane>
                                <Tab.Pane eventKey="addtionals">
                                    <h5 className='fw-600'>{t('Additional Hours')}</h5>
                                    {timelog.data?.extraPayments && Object.values(timelog.data?.extraPayments).length ? (
                                        <>
                                            {commonStore.config?.client?.data?.extraPayments?.length &&
                                                <div className='font-size-15 fw-semibold' style={{ color: '#446bbb' }}>
                                                    {t('Time&Control suggests that you double-check all the additional payments before approving and sending them to payroll to avoid any mistakes')}.
                                                </div>
                                            }
                                            <div className="row timelog-grid-time-card">
                                                {commonStore.config.client.data?.extraPayments.length &&
                                                    commonStore.config.client.data.extraPayments.map((extraPayment, index) =>
                                                        timelog.data?.extraPayments[extraPayment.code]?.value ? (
                                                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className='timelog-grid-extra-payment-item_approval justify-content-space-between card-timelog-grid-item ' key={`${index}_${extraPayment.code}`}>
                                                                <div className='d-flex align-items-center'>
                                                                    <span className="timelog-grid__text timelog-grid__text-capitalize w-100">
                                                                        {extraPayment.name}
                                                                    </span>
                                                                </div>
                                                                <OverlayTrigger
                                                                    key={extraPayment?.name}
                                                                    placement="top"
                                                                    overlay={<Tooltip id="tooltip-top">{t('Add Additional Payments Hours')}</Tooltip>}
                                                                >
                                                                    <div>
                                                                        {/* Display format follows the saved entry's type (it may differ from the rule after a type change). */}
                                                                        {(timelog.data?.extraPayments[extraPayment.code]?.extraPaymentType?.value || extraPayment?.extraPaymentType?.value) === 'manual_point_amount' ?
                                                                            // Quantity: stored and shown as the point itself (0-1.0).
                                                                            <NumberInput
                                                                                style={{ maxWidth: '85px' }}
                                                                                customClassses="text-center"
                                                                                step="0.1"
                                                                                min={0}
                                                                                max={1}
                                                                                disabled
                                                                                value={timelog.data?.extraPayments[extraPayment.code]?.value || 0}
                                                                            />
                                                                            : (timelog.data?.extraPayments[extraPayment.code]?.extraPaymentType?.value || extraPayment?.extraPaymentType?.value) === 'fixed_hourly_amount' || extraPayment.code === 'shift_allowance' ?
                                                                                <NumberInput
                                                                                    style={{ maxWidth: '85px' }}
                                                                                    customClassses="text-center"
                                                                                    disabled={!extraPayment.isEditable || shiftAllowance?.amount}
                                                                                    value={timelog.data?.extraPayments[extraPayment.code]?.value
                                                                                        ? timelog.data?.extraPayments[extraPayment.code]?.value
                                                                                        : 0}
                                                                                />
                                                                                :
                                                                                <InputTime
                                                                                    disabled
                                                                                    value={
                                                                                        timelog.data?.extraPayments[extraPayment.code]?.value
                                                                                            ? minutesToTimeInput(timelog.data?.extraPayments[extraPayment.code]?.value)
                                                                                            : '00:00'
                                                                                    }
                                                                                    className="big-input text-center"
                                                                                />
                                                                        }
                                                                    </div>
                                                                </OverlayTrigger>
                                                            </Col>
                                                        ) :
                                                            <></>
                                                    )}
                                                {commonStore.config.client.data?.extendedRules.kilometersRules?.length &&
                                                    commonStore.config.client.data.extendedRules.kilometersRules.map((extraPayment, index) =>
                                                        !!timelog.data?.extraPayments[extraPayment.distance.replaceAll(" ", "").toLocaleLowerCase()]?.value && (
                                                            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className='timelog-grid-extra-payment-item_approval justify-content-space-between card-timelog-grid-item ' key={`${index}_${extraPayment.code}`}>
                                                                <div className='d-flex align-items-center'>
                                                                    <span className="timelog-grid__text timelog-grid__text-capitalize w-100">
                                                                        {t('Km/Miles Reimbursement')} ({extraPayment.distance})
                                                                    </span>
                                                                </div>
                                                                <OverlayTrigger
                                                                    key={extraPayment?.distance}
                                                                    placement="top"
                                                                    overlay={<Tooltip id="tooltip-top">{t('These will be automatically filled by the system')}</Tooltip>}
                                                                >
                                                                    <div>
                                                                        <NumberInput
                                                                            style={{ maxWidth: '85px' }}
                                                                            customClassses="text-center"
                                                                            disabled={!extraPayment.isEditable}
                                                                            value={timelog.data?.extraPayments[extraPayment.distance.replaceAll(" ", "").toLocaleLowerCase()]?.value
                                                                                ? timelog.data?.extraPayments[extraPayment.distance.replaceAll(" ", "").toLocaleLowerCase()]?.value
                                                                                : 0}
                                                                        />
                                                                    </div>
                                                                </OverlayTrigger>
                                                            </Col>
                                                        )
                                                    )}
                                            </div>
                                        </>
                                    ) : <div className='text-center'>
                                        {t('No Additional Hours Registered')}!
                                    </div>
                                    }
                                </Tab.Pane>
                                {this.state.cost_units &&
                                    <Tab.Pane eventKey="costUnits">
                                        <h5 className='fw-600'>{t('Cost Units')}</h5>
                                        <CostUnitsAndTypeWidget
                                            value={timelog?.data?.cost_units}
                                            onChange={(value) => this.handleCostUnitChange(value)}
                                            hasErrorCallBack={(value, hasError) => this.handleCostUnitsError(value, hasError)}
                                        />
                                    </Tab.Pane>
                                }
                                {!!this.currentIntegrationProduct && <Tab.Pane eventKey="payrollHistory">
                                    <h5 className='fw-600'>{t('Payroll')} {t('history')}</h5>
                                    {timelog.data?.integrationSyncHistory?.length > 0 ? <div className='timelog-array__right w-100'>
                                        <PayrollHistoryTable integrationSyncHistory={timelog.data.integrationSyncHistory} dateTimeRules={dateTimeRules} />
                                    </div>
                                        :
                                        <div className='text-center'>
                                            {t('No payroll history found!')}
                                        </div>
                                    }
                                </Tab.Pane>
                                }
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row >
                {timelog.conflictMessage && (
                    <div className="mt-2 mb-1">
                        <span className="fw-bold ">{t('Warning')}:&nbsp;</span>
                        <span className="text-warning">{t(timelog.conflictMessage)}</span>
                    </div>
                )}
                <Row className="mt-20">
                    <Col>
                        <Textarea
                            label={`${t('Add')} ${t('Notes')}`}
                            value={this.props.admin_note ? this.props.admin_note : this.state.admin_note}
                            onChange={e => this.setState({ admin_note: e.target.value })}
                            placeholder={t('Enter Notes here')}
                            required
                            timelog_modal={"_timelog"}
                        />
                    </Col>
                    <Col>
                        <Textarea
                            label={t('Comment')}
                            value={this.props.notes ? this.props.notes : this.state.notes}
                            onChange={(e) => this.setState({ notes: e.target.value })}
                            placeholder={t('Enter comments here')}
                            required
                            timelog_modal={"_timelog"}
                        />
                    </Col>
                </Row>
                {timelog.showOvertimeComment &&
                    <Row className="mt-12">
                        <Col>
                            <div className="d-flex align-items-center mb-1">
                                <span className="input-block__label">{t('Overtime Comment')}</span>
                                {timelog.isOvertimeCommentMissing &&
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t('Comment for overtime is missing')}
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-exclamation-triangle text-warning ms-2" aria-hidden="true"></i>
                                    </OverlayTrigger>
                                }
                            </div>
                            <Textarea
                                value={timelog.overtime_comment || ''}
                                disabled
                                timelog_modal={"_timelog"}
                            />
                        </Col>
                    </Row>
                }
                {!!this.currentIntegrationProduct &&
                    <>
                        <div className='mt-2 d-flex justify-content-start'
                            title={!this.state.validationMessage ? t('Sync with integration') : t(this.state.validationMessage)}>
                            <div className='mt-1'>
                                <SwitchWidget
                                    value={this.state.syncWithIntegration}
                                    onChange={checked => this.handleSyncSwitch(checked)}
                                    disabled={this.isStatusUpdated() || (!this.state.validationMessage && !this.state.isAlreadySynced ? false : true)}
                                />
                            </div>
                            <div>
                                <label className='ml-10'>{t(`Do You want to Save the hours to`)} <span className='text-capitalize'>{this.currentIntegrationProduct}</span>?</label>
                            </div>
                        </div>
                        {this.state.validationMessage &&
                            <span className='text-danger fw-bold font-size-12'>{t('Warning')}:&nbsp;{t(this.state.validationMessage)}</span>
                        }
                    </>
                }
                {(!!fromChangedBy || !!toChangedBy || !!breakChangedBy) &&
                    <div className="row mt-2">
                        <Col xs={12} className="d-flex justify-content-start">
                            <p className='font-size-15 fw-bold mt-2'>{t("Change History")}</p>
                        </Col>
                        <Col xs={12}>
                            {fromChangedBy && (previousFrom || previousFrom === 0) && (
                                <p style={{ margin: 0 }}>
                                    {t(this.convertUserTypeToText(fromChangedBy.user_type))}{' '}
                                    {fromChangedBy.first_name || ''} {fromChangedBy.last_name || ''}{' '}
                                    {t('changed start time from')} {timeFormat(previousFrom, dateTimeRules)}{' '}
                                    {t('to')} {timeFormat(timelog.from, dateTimeRules)}
                                </p>
                            )}
                            {toChangedBy && (previousTo || previousTo === 0) && (
                                <p style={{ margin: 0 }}>
                                    {t(this.convertUserTypeToText(toChangedBy.user_type))}{' '}
                                    {toChangedBy.first_name || ''} {toChangedBy.last_name || ''}{' '}
                                    {t('changed end time from')} {timeFormat(previousTo, dateTimeRules)} {t('to')}{' '}
                                    {timeFormat(timelog.to || 0, dateTimeRules)}
                                </p>
                            )}
                            {breakChangedBy && (previousBreak || previousBreak === 0) && (
                                <p style={{ margin: 0 }}>
                                    {t(this.convertUserTypeToText(breakChangedBy.user_type))}{' '}
                                    {breakChangedBy.first_name || ''} {breakChangedBy.last_name || ''}{' '}
                                    {t('changed break time from')} {minutesToTimeInput(previousBreak)} {t('to')}{' '}
                                    {minutesToTimeInput(timelog.break)}
                                </p>
                            )}
                        </Col>
                    </div>
                }
                {
                    <div className='timelog-right-fade-modal-container'>
                        <div className="timelog-modal-accept-buttons">
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-save-accept">
                                {isSelfApprovalBlocked ?
                                    selfApprovalMessage :
                                    !timelog.is_editable ?
                                        t('Cannot manage this timesheet') :
                                        this.isStatusUpdated() ?
                                            t('Please reset first to change approval status') :
                                            !this.isDataModified() ?
                                                t('Please update and then try to save')
                                                : t('Save and accept')}
                            </Tooltip>}>
                                <Button fill wd icon
                                    style={{ backgroundColor: 'blue', border: 0, opacity: !this.isStatusUpdated() && this.isDataModified() && !isSelfApprovalBlocked ? "1" : "0.5" }}
                                    onClick={() => this.saveOneAndAccept()}
                                    disabled={!timelog.is_editable || this.isStatusUpdated() || !this.isDataModified() || isSelfApprovalBlocked}
                                >
                                    <img src={SaveAndAcceptIcon} alt="SaveAndAcceptIcon" /> {t('Save and accept')}
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-approve">
                                {isSelfApprovalBlocked ? selfApprovalMessage : this.isStatusUpdated() ? t('Please reset first to change approval status') : t('Approve')}
                            </Tooltip>}>
                                <Button fill wd icon style={{ backgroundColor: 'green', border: 0, alignItems: 'center' }}
                                    onClick={() => this.handleRun('approved')}
                                    disabled={this.isStatusUpdated() || isSelfApprovalBlocked}
                                >
                                    <img src={ApprovalIcon} alt="ApprovalIcon" /> {t('Accept original')}
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-reject">
                                {isSelfApprovalBlocked ? selfApprovalMessage : this.isStatusUpdated() ? t('Please reset first to change approval status') : t('Reject')}
                            </Tooltip>}>
                                <Button fill wd icon style={{ backgroundColor: 'red', border: 0 }}
                                    onClick={() => this.handleRun('rejected')}
                                    disabled={this.isStatusUpdated() || isSelfApprovalBlocked}
                                >
                                    <img src={RejectIcon} alt="RejectIcon" /> {t('Reject')}
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-reset">
                                {isSelfApprovalBlocked ? selfApprovalMessage : !this.isStatusUpdated() ? t('Pending approval') : t('Reset status')}
                            </Tooltip>}>
                                <Button fill wd icon
                                    style={{ backgroundColor: 'darkorange', border: 0, opacity: this.isStatusUpdated() && !isSelfApprovalBlocked ? "1" : "0.5" }}
                                    onClick={() => this.handleRun('reset')}
                                    disabled={!this.isStatusUpdated() || isSelfApprovalBlocked}
                                >
                                    <img src={ResetApprovalIcon} alt="ResetApprovalIcon" /> {t('Reset')}
                                </Button>
                            </OverlayTrigger>
                        </div>
                    </div>
                }

                {showUrgentCallModal &&
                    <UrgentCallModal
                        userId={timelog.user_id}
                        forDate={moment(timelog.for_date).format('YYYY-MM-DD')}
                        handleUrgentCallModal={this.handleUrgentCallModal}
                    />
                }

                <UserPromptModal
                    source={userPromptModal.source}
                    header={userPromptModal.header}
                    showModal={userPromptModal.showModal}
                    sourceInfo={userPromptModal.sourceInfo}
                    actions={userPromptModal.actions}
                    actionMethods={userPromptModal.actionMethods}
                />
            </div>
        );
        //timelog grid --end//
    }
}

export default inject('timelogStore', 'absenceStore', 'commonStore', 'userStore', 'scheduleStore', 'vacationStore'
)(applicationRouter(withLocalization(observer(ModalAccept))));